import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OptimizelyService } from '~shared/services/optimizely.service';
import { CATEGORY_NAVIGATION_REDESIGN } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class CategoryNavigationService {
  private _sidenavSubject = new Subject<void>();
  sidenav$ = this._sidenavSubject.asObservable();

  constructor(private optimizelyService: OptimizelyService) {}

  toggleSidenav(): void {
    this._sidenavSubject.next();
  }

  isSidenavMenuEnabled(): Observable<string> {
    return this.optimizelyService.getExperimentVariant(CATEGORY_NAVIGATION_REDESIGN);
  }
}
